import type { FC, ReactNode } from 'react'

import { SplitText } from '@/components/motion/split-text'
import { Reveal } from '@/components/motion/reveal'
import { SectionHeading } from '@/components/site/section-heading'
import { processIntro, processSteps } from '@/constants/about'

export const AboutProcess: FC = (): ReactNode => {
    return (
        <section
            id='process'
            className='relative z-[2] flex w-full flex-col gap-6 overflow-clip bg-background px-4 pb-section-sm lg:flex-row lg:items-start lg:px-6'
        >
            <div className='relative z-[1] w-full lg:sticky lg:top-24 lg:max-w-[32%] lg:flex-1'>
                <SectionHeading lead="Four" title="steps" />
            </div>

            <div className='flex w-full flex-col gap-10 lg:flex-1 lg:pt-section-sm'>
                <SplitText
                    as='p'
                    text={processIntro}
                    effect='rise'
                    by='word'
                    stagger={0.03}
                    className='t-lead max-w-[620px] py-6 text-left text-umber'
                />

                <ol className='flex w-full flex-col border-t border-border'>
                    {processSteps.map((step) => (
                        <li key={step.title} className='border-b border-border'>
                            <Reveal y={20}>
                                <article className='grid grid-cols-1 gap-5 py-8 text-foreground md:grid-cols-[minmax(0,0.9fr)_minmax(0,1fr)] md:gap-6 lg:py-10'>
                                    <div className='flex items-baseline gap-3'>
                                        <span className='t-number shrink-0'>
                                            {step.number}
                                        </span>

                                        <h3 className='t-name text-left'>
                                            {step.title}
                                        </h3>
                                    </div>

                                    <div className='flex flex-col gap-3 md:pt-2'>
                                        <p className='t-italic text-left text-umber'>
                                            {step.duration}
                                        </p>

                                        <p className='t-body max-w-[520px] text-left text-muted-foreground'>
                                            {step.text}
                                        </p>
                                    </div>
                                </article>
                            </Reveal>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    )
}
